import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Environment } from '@r1-compass-library/environments/environment';
import { ContentAsset } from '@r1-compass-library/models';
import { ContentAssetSearch } from '@r1-compass-library/models/search/content-asset-search.model';
import { Observable, catchError, finalize, of } from 'rxjs';
import { HttpHeaderConstants } from '@r1-compass-library/constants';
import { AssetRestService } from './rest/asset-rest.service';

@Injectable({
    providedIn: 'root',
})
export class ContentAssetService extends AssetRestService<ContentAsset, ContentAssetSearch> {
    protected override BASE_URL: string = Environment.baseUrl + '/frontend/content-assets';
    protected override TARGET_OBJECT = 'content-asset';

    processNamePrefix = 'ContentAssetService';

    unlinkImporter(assetId: number, additionalHeaders: any = {}): Observable<ContentAsset> {
        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders, ...additionalHeaders }),
        };
        const process = `${this.processNamePrefix}.unlinkImporter`;
        this.spinnerService.addProcess(process, `Unlinking play from ${this.TARGET_OBJECT}...`);
        return this.http.put<ContentAsset>(`${this.BASE_URL}/${assetId}/unlink-importer`, {}, httpOptions).pipe(
            catchError(() => of<ContentAsset>()),
            finalize(() => this.spinnerService.completeProcess(process))
        );
    }
}
